import { useState, useEffect } from 'react';
import { supabase } from '../lib/common/supabase';
import { useAuth } from '../contexts/AuthContext';

export function useRecruiterPermission(permissionName: string) {
    const { profile } = useAuth();
    const [hasPermission, setHasPermission] = useState<boolean | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        async function checkPermission() {
            if (!profile || !profile.id) {
                setHasPermission(false);
                setIsLoading(false);
                return;
            }


            if (profile.company_role === 'admin') {
                setHasPermission(true);
                setIsLoading(false);
                return;
            }


            if (profile.company_role !== 'recruiter') {
                setHasPermission(false);
                setIsLoading(false);
                return;
            }

            try {
                const { data, error } = await supabase.rpc('user_has_recruiter_permission', {
                    p_user_id: profile.id,
                    p_permission_name: permissionName
                });

                if (error) {
                    console.error('Error checking permission:', error);
                    setHasPermission(false);
                } else {
                    setHasPermission(data);
                }
            } catch (err) {
                console.error('Error checking permission:', err);
                setHasPermission(false);
            } finally {
                setIsLoading(false);
            }
        }

        checkPermission();
    }, [profile, permissionName]);

    return { hasPermission, isLoading };
}